import { validateMobileDeepLink, validateUrlLink } from '../../../utils';

export type FormValues = {
  redirect_uris: string[];
  name: string;
  description: string;
  lifetime: number;
  logoUrl: string;
  audience: string[];
  scopes: string[];
};

type FormValuesValidate = {
  redirect_uris?: string[] | string;
  name?: string;
  description?: string;
  lifetime?: string;
  audience?: string[] | string;
  scopes?: string[];
};

export const clientNameMaxLength = 255;
export const clientDescriptionMaxLength = 255;

const validateUris = (linkString: string) =>
  validateUrlLink(linkString) || validateMobileDeepLink(linkString);

export const Oauth2ModalValidator = (values: FormValues): FormValuesValidate => {
  const errors: FormValuesValidate = {};

  if (!values.name || !values.name.trim()) {
    errors.name = 'app.validation.required';
  }
  if (values.name && values.name.length > clientNameMaxLength) {
    errors.name = 'app.validation.characters';
  }

  if (!values.description || !values.description.trim()) {
    errors.description = 'app.validation.required';
  }
  if (values.description?.length > clientDescriptionMaxLength) {
    errors.description = 'app.validation.characters';
  }

  if (values.redirect_uris.length === 0) {
    errors.redirect_uris = 'app.validation.required';
  } else if (values.redirect_uris.filter((i) => !!i).length) {
    const accum = Object.create(null);
    const uriErrors = values.redirect_uris.map((fieldValue) => {
      const urlErr =
        !validateUris(fieldValue) && 'authorization.settings.oauth2.validation.invalid-url';
      const duplicateErr =
        accum[fieldValue] && 'authorization.settings.oauth2.validation.duplicate-url';
      accum[fieldValue] = true;
      return urlErr || duplicateErr;
    });
    if (uriErrors.some(Boolean)) {
      errors.redirect_uris = uriErrors;
    }
  } else {
    errors.redirect_uris = values.redirect_uris.map(() => 'app.validation.required');
  }

  if (values.audience.length === 0) {
    errors.audience = 'app.validation.required';
  } else if (values.audience.filter((i) => !!i).length) {
    const accum = Object.create(null);
    const audienceErrors = values.audience.map((fieldValue) => {
      const urlErr =
        !validateUris(fieldValue) && 'authorization.settings.oauth2.validation.invalid-url';
      const duplicateErr =
        accum[fieldValue] && 'authorization.settings.oauth2.validation.duplicate-url';
      accum[fieldValue] = true;
      return urlErr || duplicateErr;
    });
    if (audienceErrors.some(Boolean)) {
      errors.audience = audienceErrors;
    }
  } else {
    errors.audience = values.audience.map(() => 'app.validation.required');
  }

  if (values.scopes.length === 0 && !values.scopes[0].trim()) {
    errors.scopes = ['app.validation.required'];
  } else {
    const scopeErrors: string[] = [];
    let hasScopeErrors = false;
    values.scopes.forEach((fieldValue, index, allScopes) => {
      if (!fieldValue || !fieldValue.trim()) {
        scopeErrors[index] = 'app.validation.required';
        hasScopeErrors = true;
      } else if (allScopes.indexOf(fieldValue) !== index) {
        scopeErrors[index] = 'authorization.settings.oauth2.validation.duplicate-url';
        hasScopeErrors = true;
      }
    });
    if (hasScopeErrors) {
      errors.scopes = scopeErrors;
    }
  }

  if (!values.lifetime) {
    errors.lifetime = 'app.validation.required';
  }

  if (Number(values.lifetime) < 300) {
    errors.lifetime = 'app.validation.value-less';
  }

  if (Number(values.lifetime) > 432000) {
    errors.lifetime = 'app.validation.value-more';
  }

  return errors;
};
